
import { put, call, takeEvery, select, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import { Endpoints } from 'services/api';
import errorHandler from 'common/errorHandler';

const getTenant = (state) => state.userLogin.tenant;

function* getEventSchemaModel(api, tenantId, eventId, schemaId) {
    try {
        let result = yield call([api, api.get], `${Endpoints.events}/api/v1/events/${eventId}/schemas/${schemaId}`, { tenantid: tenantId });
        return result.data;
    }
    catch (error) {
        if (error.isAxiosError) {
            if (error.response && error.response.status === 404) {
                return null;
            }
        }
        throw error;
    }
}

export function* getEventSchemaModelRequest(api, { eventId, schemaId }) {
    try {
        let tenant = yield select(getTenant);
        const schemaModelRevision = yield call(getEventSchemaModel, api, tenant.tenantId, eventId, schemaId);
        yield put(actions.getEventSchemaModelSuccess(schemaModelRevision));
    } catch (error) {
        let errorObject = errorHandler(error, "Get", "event schema details");
        yield put(actions.getEventSchemaModelFailure(errorObject));
    }
}

export function* watchGetEventSchemaModelRequest(api, { params }) {
    yield call(getEventSchemaModelRequest, api, params);
}

export default function* ({ api }) {
    yield takeLatest(actions.GET_EVENT_SCHEMA_MODEL_REQUEST, watchGetEventSchemaModelRequest, api);
}